import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  makeGETRequestOnUserService,
  makePOSTRequestOnUserService,
  makePUTRequestOnUserService,
} from "../../Api/api";
import Skeleton from "@mui/material/Skeleton";
import PanCardInformationGrid from "./PanCardInformationGrid";
import {
  PanDetails,
  PanDetailsUpdate,
  ProofOfAddress,
} from "../../pages/WhatsappCampaign/Interfaces";
import ProofOfAddressInformationGrid from "./ProofOfAddressInformationGrid";
import ProofOfNRIInformationGrid from "./ProofOfNRIInformationGrid";
import KYCBankDetailsTab from "./KYCBankDetailsTab";
import KYCDematDetailsTab from "./KYCDematDetailsTab";
import PersonalDetails from "./PersonalDetails";
import CompleteKYC from "./CompleteKYC";
import Badge from "@mui/material/Badge";
import { Select, Button } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import OfficeUseActions from "./OfficeUseActions";
import NomineeDetails from "./NomineeDetails";
import RiskProfiling from "./RiskProfiling";
import KartaDetails from "./KartaDetails";
import CKYCInformation from "./CKYCInformation";
import { format } from "date-fns";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function getAccountTypeLabel(accountTypeKey: string): string | undefined {
  const accountTypeMapping: Record<string, string> = {
    individual_resident: "Individual Resident",
    individual_non_resident: "Individual Non-Resident",
    huf: "Hindu Undivided Family",
    sole_proprietor: "Sole Proprietor",
    llp: "Limited Liability Partnership",
    partnership: "Partnership",
    privated_limited: "Private Limited",
    trust: "Trust",
    public_limited: "Public Limited",
    None: "None",
  };

  return accountTypeMapping[accountTypeKey];
}

export default function NewKYCDetailsTab(props: any) {
  const [value, setValue] = React.useState(0);
  const { currentUser } = props;
  const toastr = require("toastr");
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [panCardDetails, setPanCardDetails] = React.useState<any>(null);
  const [proofOfAddressDetails, setProofOfAddressDetails] =
    React.useState<any>(null);
  const [bankDetails, setBankDetails] = React.useState<any>(null);
  const [dematDetails, setDematDetails] = React.useState<any>(null);
  const [originalDematDetails, setOriginalDematDetails] =
    React.useState<any>(null);
  const [originalPanNumber, setOriginalPanNumber] = React.useState("");
  const [ckycDetails, setCkycDetails] = React.useState<any>(null);
  const [userDetails, setUserDetails] = React.useState<any>(null);
  const formDataInitialState = {
    maritalStatus: "",
    politicallyExposed: "",
    maidenName: "",
    mothersName: "",
    annualIncome: "",
    gender: "",
    occupation: "",
    qualification: "",
    differentlyAbledStatus: "",
    typeOfImpairment: "",
    percentageOfImpairment: "",
    UDIDNumber: "",
    wetSignImage: null as File | null,
    passportPhoto: null as File | null,
    sebi_action: false,
    investment_trading_experience: "",
    status: "",
    is_merchant_navy_nri: false,
    merchant_navy_document_type: "",
    merchant_navy_document: null as File | null,
    tax_resident_other_country: false,
    tax_residency_details: [] as any[],
    birthCity: "",
    birthCountry: "",
    nationality: "",
  };
  const [formData, setFormData] = React.useState(formDataInitialState);
  const [currentAccountType, setCurrentAccountType] = React.useState(
    currentUser?.accountType || ""
  );
  const [accountType, setSelectedAccountType] = React.useState(
    getAccountTypeLabel(currentUser?.accountType) || ""
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const loginUser = JSON.parse(localStorage.getItem("loginUser")!);

  const isNRI = currentAccountType === "individual_non_resident";

  function incrementTabBy1(event: any) {
    event.preventDefault();
    setValue(value + 1);
  }

  const fetchKycDocs = React.useCallback(() => {
    if (!currentUser?.uuid) return Promise.resolve();
    makeGETRequestOnUserService(`/kyc/kyc_docs/list/${currentUser.uuid}/`)
      .then((response) => {
        if (response && response.status === 200) {
          setPanCardDetails(response.data.pan_card);
          setUserDetails(response.data?.personal_details);
          setOriginalPanNumber(response.data?.pan_card?.uuid);
          setProofOfAddressDetails(response.data.poa);
          setBankDetails(response.data.bank_details);
          const demats = Array.isArray(response.data.demat_details)
            ? response.data.demat_details
            : response.data.demat_details
              ? [response.data.demat_details]
              : [];
          setDematDetails(demats);
          setOriginalDematDetails(demats);
          setFormData(response?.data.personal_details || formDataInitialState);
          setCkycDetails(response.data.ckyc_details);
          // setIsLoaded(!isLoaded);
          setIsLoaded(true);
        }
      })
      .catch((error) => toastr.error(error));
  }, [currentUser?.uuid]);

  React.useEffect(() => {
    fetchKycDocs();
  }, [fetchKycDocs]);

  function nullifyPanCard(event: any): any {
    event.preventDefault();
    setPanCardDetails(null);
  }

  function nullifyProofOfAddress(event: any): any {
    event.preventDefault();
    setProofOfAddressDetails(null);
  }

  const savePanCardDetails = (event: any, panCardDetails: PanDetailsUpdate) => {
    event.preventDefault();
    panCardDetails.uuid = panCardDetails.panCardNumber;

    if (panCardDetails.image instanceof File) {
      const formData = new FormData();
      formData.append("user_id", currentUser.uuid);
      formData.append("admin_name", loginUser?.name || "");
      formData.append("fathers_name", panCardDetails.fathersName);
      formData.append(
        "dob",
        panCardDetails.dateOfBirth
          ? format(new Date(panCardDetails.dateOfBirth), "yyyy-MM-dd")
          : ""
      );
      formData.append("name", panCardDetails.name);
      if (panCardDetails.uuid) formData.append("uuid", panCardDetails.uuid);
      formData.append("kyc_doc_plaintext_password", panCardDetails.kyc_doc_plaintext_password || "");
      formData.append("image", panCardDetails.image); // Append the actual File object

      makePUTRequestOnUserService("/kyc/pan_card/update/", formData)
        .then((response: any) => {
          if (response && response.status === 200) {
            toastr.success("Updated user details successfully!");
            setOriginalPanNumber(response.data.uuid);
          }
        })
        .catch((error: any) => toastr.error(error));
    } else {
      let updatedPayload: any = {
        user_id: "",
        fathers_name: "",
        dob: "",
        name: "",
        uuid: "",
        kyc_doc_plaintext_password: "",
        pan_status_response: {},
        admin_name: "",
      };

      updatedPayload.user_id = currentUser.uuid;
      updatedPayload.fathers_name = panCardDetails.fathersName;
      updatedPayload.dob = panCardDetails.dateOfBirth
        ? format(new Date(panCardDetails.dateOfBirth), "yyyy-MM-dd")
        : "";
      updatedPayload.name = panCardDetails.name;
      updatedPayload.uuid = panCardDetails.uuid;
      updatedPayload.kyc_doc_plaintext_password = panCardDetails.kyc_doc_plaintext_password;
      updatedPayload.pan_status_response = panCardDetails.pan_status_response;
      updatedPayload.admin_name = loginUser?.name || "";

      if (originalPanNumber === updatedPayload.uuid) {
        delete updatedPayload.uuid;
      }

      makePUTRequestOnUserService("/kyc/pan_card/update/", updatedPayload)
        .then((response: any) => {
          if (response && response.status === 200) {
            toastr.success("Updated user details successfully!");
            setOriginalPanNumber(response.data.uuid);
            fetchKycDocs();
          }
        })
        .catch((error: any) => toastr.error(error));
    }
  };

  function addPanCardDetails(event: any, panDetails: PanDetails) {
    event.preventDefault();
    let formData = new FormData();
    let requestURL = "/kyc/pan_card/create/";

    formData.append("type", panDetails.type || "pan");

    if (panDetails.type !== "form_60") {
      formData.append("uuid", panDetails.panCardNumber);
      formData.append("name", panDetails.name);
    }

    formData.append("fathers_name", panDetails.fathersName);
    formData.append("image", panDetails.image);
    formData.append("user_uuid", currentUser.uuid);
    formData.append("admin_name", loginUser?.name || "");
    formData.append(
      "dob",
      panDetails.dateOfBirth
        ? format(new Date(panDetails.dateOfBirth), "yyyy-MM-dd")
        : ""
    );
    const kycPassword =
      (panDetails as any).kyc_doc_plaintext_password ??
      (panDetails as any).kycPassword ??
      "";
    formData.append("kyc_doc_plaintext_password", kycPassword);

    makePOSTRequestOnUserService(requestURL, formData)
      .then((response) => {
        if (response && response.status === 201) {
          toastr.success(panDetails.type === "form_60" ? "Added Form 60 for User!" : "Added Pan Card for User!");
          incrementTabBy1(event);
          setPanCardDetails(response.data);
          fetchKycDocs();
        }
      })
      .catch((error) => toastr.error(error));
  }

  const saveProofOfAddress = (event: any, details: any, docType: any) => {
    details.user_id = currentUser.uuid;
    details.address_type = details.address_type;
    details.admin_name = loginUser?.name || "";
    let documentType = getDocumentType(docType);

    //@ts-ignore
    if (["passport", "driver_license"].includes(documentType)) {
      if (details.expiryDate instanceof Date) {
        details.expiry_date = formatDate(details.expiryDate);
      } else {
        details.expiry_date = details.expiryDate;
      }
    }
    if (documentType === "passport" && details.passport_type) {
      details.passport_type = details.passport_type;
    } else {
      delete details.passport_type;
    }

    details.district_or_city = details.districtOrCity;

    let requestURL = `/kyc/${documentType}/update/`;
    makePUTRequestOnUserService(requestURL, details)
      .then((response) => {
        if (response && response.status === 200) {
          toastr.success("Updated Proof of address details successfully !");
          fetchKycDocs();
          setProofOfAddressDetails({
            image: proofOfAddressDetails.image,
            uuid: details.uuid,
            address: details.address,
          }); 
        }
      })
      .catch((error) => toastr.error(error));
  };

  function saveBankDetails(
    event: any,
    bankDetails: any,
    selectedFile: File | null
  ) {
    let formData = new FormData();

    formData.append("account_number", bankDetails.accountNumber);
    formData.append("user_id", currentUser.uuid);
    formData.append("bank_name", bankDetails.bankName);
    formData.append("beneficiary_name", bankDetails.beneficiaryName);
    formData.append("ifsc_code", bankDetails.ifscCode);
    formData.append("branch_name", bankDetails.branchName);
    formData.append("kyc_doc_plaintext_password", bankDetails.kycPassword);
    formData.append("account_type", bankDetails.accountType);
    if (currentAccountType === "individual_non_resident") {
      if (bankDetails.nriBankAccountType) {
        formData.append(
          "nri_bank_account_type",
          bankDetails.nriBankAccountType
        );
      }

      if (bankDetails.nriBankAccountType === "nre") {
        formData.append("pis_type", bankDetails.pisType || "");
      }

      if (bankDetails.nriBankProof) {
        formData.append("nri_bank_proof", bankDetails.nriBankProof);
      }
    }

    if (!isNRI && selectedFile) {
      formData.append("image", selectedFile);
    } else if (isNRI) {
      formData.append("image", "");
    }

    let requestURL = "/kyc/bank_detail/update/";
    makePUTRequestOnUserService(requestURL, formData)
      .then((response) => {
        if (response && response.status === 200) {
          toastr.success("Updated bank details details successfully !");
          setBankDetails((prev: any[]) =>
            prev.map((d) => (d.account_number === response.data.account_number ? response.data : d))
          );
          fetchKycDocs();
        }
      })
      .catch((error) => toastr.error(error));
  }

  function nullifyBankDetails(event: any, selectedForDelete: any) {
    event.preventDefault();
    setBankDetails(
      bankDetails.filter(
        (details: any) =>
          details.account_number !== selectedForDelete.toString()
      )
    );
  }

  function addBankDetails(event: any, bankDetails: any, file: any) {
    bankDetails.user_id = currentUser.uuid;

    let formData = new FormData();
    formData.append("account_number", bankDetails.accountNumber);
    formData.append("ifsc_code", bankDetails.ifscCode);
    formData.append("bank_name", bankDetails.bankName);
    if (!isNRI && file) {
      formData.append("image", file);
    } else {
      formData.append("image", "");
    }
    formData.append("user_id", currentUser.uuid);
    formData.append("beneficiary_name", bankDetails.beneficiaryName);
    formData.append("perform_penny_drop", "false");
    formData.append("branch_name", bankDetails.branchName);
    formData.append("kyc_doc_plaintext_password", bankDetails.kycPassword);
    formData.append("account_type", bankDetails.accountType);
    if (currentAccountType === "individual_non_resident") {
      if (bankDetails.nriBankAccountType) {
        formData.append(
          "nri_bank_account_type",
          bankDetails.nriBankAccountType
        );
      }

      if (bankDetails.nriBankAccountType === "nre") {
        formData.append("pis_type", bankDetails.pisType || "");
      }

      if (bankDetails.nriBankProof) {
        formData.append("nri_bank_proof", bankDetails.nriBankProof);
      }
    }

    makePOSTRequestOnUserService("/kyc/bank_detail/create/", formData)
      .then((response) => {
        if (response && response.status === 201) {
          toastr.success("Added bank details details successfully !");
          setBankDetails(response.data);
          incrementTabBy1(event);
          fetchKycDocs();
        }
      })
      .catch((error) => toastr.error(error));
  }

  function getDocumentType(type: string) {
    if (type === "Aadhar") return "aadhar_card";
    else if (type === "Passport") return "passport";
    else if (type === "Driver License") return "driver_license";
  }

  function formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear().toString();

    return `${day}/${month}/${year}`;
  }

  const createProofOfAddress = (
    event: any,
    details: ProofOfAddress,
    docType: string,
  ) => {
    let formData = new FormData();
    let documentType = getDocumentType(docType);

    //@ts-ignore
    if (["passport", "driver_license"].includes(documentType)) {
      if (details.expiryDate instanceof Date) {
        formData.append("expiry_date", formatDate(details.expiryDate));
      } else if (details.expiryDate) {
        formData.append("expiry_date", details.expiryDate);
      }
    }
    if (documentType === "passport" && details.passport_type) {
      formData.append("passport_type", details.passport_type);
    }

    formData.append("user_id", currentUser.uuid);
    formData.append("uuid", details.uuid);
    formData.append("address", details.address);
    formData.append("front_part", details.selectedFile);
    formData.append("back_part", details.selectedFile);
    formData.append("district_or_city", details.districtOrCity);
    formData.append("pincode", details.pincode);
    formData.append("state", details.state);
    formData.append("country", details?.country);
    formData.append("address_type", details.address_type);
    formData.append("admin_name", loginUser?.name || "");

    const kycPassword =
      (details as any).kyc_doc_plaintext_password ??
      (details as any).kycPassword ??
      "";
    formData.append("kyc_doc_plaintext_password", kycPassword);

    makePOSTRequestOnUserService(`/kyc/${documentType}/create/`, formData)
      .then((response) => {
        if (response && response.status === 201) {
          toastr.success("Added Proof of address for User!");
          fetchKycDocs();
          setProofOfAddressDetails(response.data);
          incrementTabBy1(event);
        }
      })
      .catch((error) => toastr.error(error));
  };

  const saveProofOfNRI = (event: any, details: any) => {
    const formData = new FormData();
    formData.append("user_id", currentUser.uuid);
    if (details.nri_is_holding) {
      formData.append("nri_is_holding", details.nri_is_holding);
    }
    if (details.proof_of_nri_document_type) {
      formData.append(
        "proof_of_nri_document_type",
        details.proof_of_nri_document_type
      );
    }
    if (details.proof_of_nri_document_password !== undefined) {
      formData.append(
        "proof_of_nri_document_password",
        details.proof_of_nri_document_password || ""
      );
    }
    if (details.proof_of_nri_document instanceof File) {
      formData.append(
        "proof_of_nri_document",
        details.proof_of_nri_document
      );
    } else {
      formData.append("proof_of_nri_document", "");
    }

    makePUTRequestOnUserService(
      "/kyc/passport/update_proof_of_nri/",
      formData
    )
      .then((response) => {
        if (response?.status === 200) {
          toastr.success("Updated Proof of NRI successfully!");
          fetchKycDocs();
          incrementTabBy1(event);
        }
      })
      .catch((error) => toastr.error(error));
  };

  const addDematDetails = (event: any, details: any) => {
    let formData = new FormData();
    formData.append("user_id", currentUser.uuid);
    formData.append("client_id", details.clientId);
    formData.append("dp_type", details.dpType);
    formData.append("dp_name", details.dpName);
    formData.append("dp_id", details.dpID);
    formData.append("file", details.file);
    formData.append("account_status", details.accountStatus);
    formData.append("pan_numbers", details.panNumbers);
    formData.append("kyc_doc_plaintext_password", details.kycPassword);
    makePOSTRequestOnUserService("/kyc/demat_detail/create/", formData)
      .then((response) => {
        if (response && response.status === 201) {
          toastr.success("Added Demat details details successfully !");
          setDematDetails((prev: any[]) => [...prev, response.data]);
          incrementTabBy1(event);
        }
      })
      .catch((error) => toastr.error(error));
  };

  function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function getDifferenceBwObjects(newObj: any, old: any) {
    const diff: any = {};
    const fieldMap = {
      clientId: "client_id",
      dpID: "dp_id",
      dpName: "dp_name",
      dpType: "dp_type",
      accountStatus: "account_status",
      panNumbers: "pan_numbers",
      kycPassword: "kyc_doc_plaintext_password"
    };

    for (const [newKey, oldKey] of Object.entries(fieldMap)) {
      if (newObj[newKey] !== old[oldKey]) {
        diff[oldKey] = newObj[newKey];
      }
    }

    const isFile = newObj.image instanceof File;
    const newImage = isFile ? await fileToBase64(newObj.image) : newObj.image;
    if (newImage !== old.image) {
      diff.image = newObj.image;
    }

    return diff;
  }

  async function checkIfCertainValuesHaveChanged(newObj: any, old: any) {
    const isFile = newObj.image instanceof File;
    const newImage = isFile ? await fileToBase64(newObj.image) : newObj.image;

    return (
      newObj.clientId === old.client_id &&
      newObj.dpID === old.dp_id &&
      newObj.dpName === old.dp_name &&
      newObj.dpType === old.dp_type &&
      newObj.accountStatus === old.account_status &&
      newObj.panNumbers === old.pan_numbers &&
      newObj.kycPassword === old.kyc_doc_plaintext_password &&
      newImage === old.image
    );
  }

  const saveDematDetails = async (event: any, dematDetails: any) => {
    event.preventDefault();
    dematDetails.userUUID = currentUser.uuid;

    if (
      await checkIfCertainValuesHaveChanged(dematDetails, originalDematDetails)
    )
      return;

    const diff = await getDifferenceBwObjects(
      dematDetails,
      originalDematDetails
    );
    const payload = { ...diff, user_id: dematDetails.userUUID };

    const formData = new FormData();
    Object.entries(payload).forEach(
      ([k, v]) => v !== "" && formData.append(k, v)
    );

    makePUTRequestOnUserService("/kyc/demat_detail/update/", formData)
      .then((res) => {
        if (res?.status === 200) {
          toastr.success("Updated demat details successfully!");
          setDematDetails((prev: any[]) =>
            prev.map((d) => (d.client_id === res.data.client_id ? res.data : d))
          );
          fetchKycDocs();
        }
      })
      .catch((err) => toastr.error(err));
  };

  const deleteDematDetailFromState = (clientId: string) => {
    setDematDetails((prev: any[]) => prev.filter((d) => d.client_id !== clientId));
  };

  function addPersonalDetails(event: any) {
    const formDataToSave = new FormData();
    formDataToSave.append("maritalStatus", formData.maritalStatus);
    formDataToSave.append("politicallyExposed", formData.politicallyExposed);
    formDataToSave.append("maidenName", formData.maidenName);
    formDataToSave.append("motherName", formData.mothersName);
    formDataToSave.append("annualIncome", formData.annualIncome);
    formDataToSave.append("gender", formData.gender);
    formDataToSave.append("occupation", formData.occupation);
    formDataToSave.append("qualification", formData.qualification);
    formDataToSave.append("differentlyAbledStatus", formData.differentlyAbledStatus);
    formDataToSave.append("typeOfImpairment", formData.typeOfImpairment);
    formDataToSave.append("percentageOfImpairment", formData.percentageOfImpairment);
    formDataToSave.append("UDIDNumber", formData.UDIDNumber);
    formDataToSave.append("birthCity", formData.birthCity);
    formDataToSave.append("birthCountry", formData.birthCountry);
    formDataToSave.append("nationality", formData.nationality);
    formDataToSave.append("userUUID", currentUser.uuid);


    if (formData.wetSignImage instanceof File) {
      formDataToSave.append("signpart", formData.wetSignImage);
    }

    if (formData.passportPhoto instanceof File) {
      formDataToSave.append("photopart", formData.passportPhoto);
    }

    if (currentAccountType === "individual_non_resident") {
      formDataToSave.append("sebi_action", String(!!formData.sebi_action));
      formDataToSave.append(
        "investment_trading_experience",
        formData.investment_trading_experience || ""
      );
      formDataToSave.append("status", formData.status || "");
      formDataToSave.append(
        "is_merchant_navy_nri",
        String(!!formData.is_merchant_navy_nri)
      );

      if (formData.is_merchant_navy_nri) {
        formDataToSave.append(
          "merchant_navy_document_type",
          formData.merchant_navy_document_type || ""
        );
        if (formData.merchant_navy_document instanceof File) {
          formDataToSave.append(
            "merchant_navy_document",
            formData.merchant_navy_document
          );
        }
      }

      formDataToSave.append(
        "tax_resident_other_country",
        String(!!formData.tax_resident_other_country)
      );

      if (formData.tax_resident_other_country) {
        formDataToSave.append(
          "tax_residency_details",
          JSON.stringify(formData.tax_residency_details || [])
        );
      }
    }

    makePUTRequestOnUserService(
      "/kyc/additional_details/update/",
      formDataToSave
    )
      .then((resp) => {
        toastr.success("Saved Personal Details successfully!");
        if (!getDisabledConditionForCompleteKYC()) {
          incrementTabBy1(event);
        }
        fetchKycDocs();
      })
      .catch((error) => {
        toastr.error(error);
      });
  }

  function AccountType() {
    const accountTypeOptions = [
      "Individual Resident",
      "Individual Non-Resident",
      "Hindu Undivided Family",
      "Sole Proprietor",
      "Limited Liability Partnership",
      "Partnership",
      "Private Limited",
      "Trust",
      "Public Limited",
    ];

    const handleSubmit = (event: any) => {
      console.log("Selected Account Type:", accountType);
      makePUTRequestOnUserService("/user/set_account_type/", {
        userUUID: currentUser.uuid,
        accountType: accountType,
      })
        .then((resp) => {
          if (resp.status === 200) {
            toastr.success("Updated Account Type for user");
            setCurrentAccountType(resp.data.accountType);
            incrementTabBy1(event);
          }
        })
        .catch((error) => {
          toastr.error(error);
        });
    };

    return (
      <div>
        <FormControl variant="outlined" style={{ width: "200%" }}>
          <InputLabel id="demo-simple-select-outlined-label">
            Account Type
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            name="accountType"
            value={accountType}
            onChange={(
              event: React.ChangeEvent<{ name?: string; value: unknown }>
            ) => {
              setSelectedAccountType(event.target.value as string);
            }}
            label="Account Type"
          >
            {accountTypeOptions.map((accountTypeOption, index) => (
              <MenuItem value={accountTypeOption} key={index}>
                {accountTypeOption}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ marginTop: "20px" }}
        >
          Submit
        </Button>
      </div>
    );
  }

  function getDisabledConditionForCompleteKYC(): boolean {
    return !(
      panCardDetails &&
      proofOfAddressDetails &&
      bankDetails &&
      dematDetails
    );
  }

  if (isLoaded) {
    return (
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          height: "fit-content",
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: "divider" }}
        >
          <Tab
            label={<Badge color="error">Account Type</Badge>}
            {...a11yProps(0)}
          />
          <Tab
            label={
              <Badge
                badgeContent={panCardDetails?.failed_count}
                color="error"
                invisible={
                  panCardDetails?.failed_count === 0 ||
                  panCardDetails?.failed_count
                }
              >
                Pan Card
              </Badge>
            }
            {...a11yProps(1)}
          />

          <Tab
            label={
              <Badge
                badgeContent={proofOfAddressDetails?.failed_count}
                color="error"
                invisible={
                  proofOfAddressDetails?.failed_count === 0 ||
                  proofOfAddressDetails?.failed_count
                }
              >
                Proof Of Address
              </Badge>
            }
            {...a11yProps(2)}
          />
          {isNRI && (
            <Tab
              label={<Badge color="error">Proof Of NRI</Badge>}
              {...a11yProps(3)}
            />
          )}
          <Tab
            label={
              <Badge
                badgeContent={bankDetails?.failed_count}
                color="error"
                invisible={
                  bankDetails?.failed_count === 0 || bankDetails?.failed_count
                }
              >
                Bank Details
              </Badge>
            }
            {...a11yProps(isNRI ? 4 : 3)}
          />

          <Tab
            label={
              <Badge
                badgeContent={dematDetails?.failed_count}
                color="error"
                invisible={
                  dematDetails?.failed_count === 0 || dematDetails?.failed_count
                }
              >
                Demat Details
              </Badge>
            }
            {...a11yProps(isNRI ? 5 : 4)}
          />

          <Tab
            label={
              currentUser?.accountType === "huf"
                ? "Karta Details"
                : "Nominee Details"
            }
            {...a11yProps(isNRI ? 6 : 5)}
          />
          <Tab label="Risk Profile" {...a11yProps(isNRI ? 7 : 6)} />
          <Tab label="Personal Details" {...a11yProps(isNRI ? 8 : 7)} />
          <Tab label="Office Use Actions" {...a11yProps(isNRI ? 9 : 8)} />
          <Tab
            label="Complete KYC"
            {...a11yProps(isNRI ? 10 : 9)}
            disabled={getDisabledConditionForCompleteKYC()}
          />
          <Tab
            label="cKYC Information"
            {...a11yProps(isNRI ? 11 : 10)}
          />
        </Tabs>
        <TabPanel value={value} index={0}>
          <AccountType />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PanCardInformationGrid
            panCard={panCardDetails}
            currentUser={currentUser}
            savePanCardDetails={savePanCardDetails}
            addPanCardDetails={addPanCardDetails}
            nullifyPanCard={nullifyPanCard}
            accountType={currentAccountType}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ProofOfAddressInformationGrid
            aadharCardDetails={proofOfAddressDetails}
            currentUser={currentUser}
            saveAadharCardDetails={saveProofOfAddress}
            createProofOfAddress={createProofOfAddress}
            nullifyProofOfAddress={nullifyProofOfAddress}
            userDetails={userDetails}
            accountType={currentAccountType}
          />
        </TabPanel>
        {isNRI && (
          <TabPanel value={value} index={3}>
            <ProofOfNRIInformationGrid
              aadharCardDetails={proofOfAddressDetails}
              currentUser={currentUser}
              userDetails={userDetails}
              saveProofOfNRI={saveProofOfNRI}
              accountType={currentAccountType}
            />
          </TabPanel>
        )}
        <TabPanel value={value} index={isNRI ? 4 : 3}>
          <KYCBankDetailsTab
            bankDetails={bankDetails}
            nullifyBankDetails={nullifyBankDetails}
            currentUser={currentUser}
            saveBankDetails={saveBankDetails}
            addBankDetails={addBankDetails}
            accountType={currentAccountType}
          />
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 5 : 4}>
          <KYCDematDetailsTab
            dematDetails={dematDetails}
            currentUser={currentUser}
            saveDematDetails={saveDematDetails}
            addDematDetails={addDematDetails}
            onDeleteDemat={deleteDematDetailFromState}
          />
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 6 : 5}>
          {currentUser?.accountType === "huf" ? (
            <KartaDetails
              areHufDocsUploaded={currentUser.areHufDocsUploaded}
              userUUID={currentUser.uuid}
            />
          ) : (
            <NomineeDetails
              areNomineeDetailsSubmitted={
                currentUser.areNomineeDetailsSubmitted
              }
              userUUID={currentUser.uuid}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 7 : 6}>
          <RiskProfiling
            isRiskProfileCompleted={currentUser.isRiskProfileCompleted}
            userUUID={currentUser.uuid}
          />
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 8 : 7}>
          <PersonalDetails
            addPersonalDetails={addPersonalDetails}
            accountType={currentAccountType}
            setFormData={setFormData}
            formData={formData}
          />
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 9 : 8}>
          <OfficeUseActions
            bankDetails={bankDetails}
            panCard={panCardDetails}
            currentUser={currentUser}
            dematDetails={dematDetails}
            proofOfAddressDetails={proofOfAddressDetails}
          />
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 10 : 9}>
          <CompleteKYC
            userUUID={currentUser.uuid}
            bankDetails={bankDetails}
            panCard={panCardDetails}
            currentUser={currentUser}
            dematDetails={dematDetails}
            proofOfAddressDetails={proofOfAddressDetails}
          />
        </TabPanel>
        <TabPanel value={value} index={isNRI ? 11 : 10}>
          <CKYCInformation
            ckycDetails={ckycDetails}
            userDetails={userDetails}
          />
        </TabPanel>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{ width: 900 }}
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Skeleton />
        <Skeleton animation="wave" />
        <Skeleton animation={false} />
        <Skeleton animation={false} />
        <Skeleton animation={false} />
        <Skeleton animation={false} />
        <Skeleton animation={false} />
        <Skeleton animation={false} />
      </Box>
    );
  }
}